import { render, staticRenderFns } from "./PageInfoBar.vue?vue&type=template&id=22a212e8&scoped=true&"
import script from "./PageInfoBar.vue?vue&type=script&lang=ts&"
export * from "./PageInfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./PageInfoBar.vue?vue&type=style&index=0&id=22a212e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a212e8",
  null
  
)

export default component.exports